import { useEffect, useContext } from "react"
import { cancelActions } from "./ROS/ROSFunctions"
import Context from "./Context"

const Safety = () => {
  const context = useContext(Context)

  // cancel all actions when a person is detected
  useEffect(() => {
    if (context.person?.new_person && context.currentTask?.hasUV) {
      console.log("found person when uv is on", context.person)
      if (context.selectedRobot.ROS === 'ROS2') {
        cancelActions({ stopall: true }, context.selectedRobot.ROS)
      } else {
        cancelActions({ stopAll: true }, context.selectedRobot.ROS)
      }
    }
  }, [context.person, context.currentTask])

  return null
}

export default Safety